import ContentLoader from 'react-content-loader';

const BannerLoader = (props) => (
  <ContentLoader height={475} width={400} speed={2} primaryColor="#f3f3f3" secondaryColor="#ecebeb" {...props}>
    <rect x="2" y="4" rx="5" ry="5" width="400" height="312" />
    <rect x="3" y="325.17" rx="0" ry="0" width="133" height="20" />
    <rect x="149" y="325.17" rx="0" ry="0" width="247.38000000000002" height="20" />
    <rect x="3" y="353.17" rx="0" ry="0" width="133" height="20" />
    <rect x="149" y="354.17" rx="0" ry="0" width="247.38000000000002" height="20" />
    <rect x="4" y="386.17" rx="0" ry="0" width="87.78" height="16" />
    <rect x="99" y="387.17" rx="0" ry="0" width="133" height="16" />
    <rect x="238" y="386.17" rx="0" ry="0" width="155.60999999999999" height="16" />
    <rect x="5" y="408.17" rx="0" ry="0" width="152.95" height="16" />
    <rect x="164" y="408.17" rx="0" ry="0" width="99.75" height="16" />
  </ContentLoader>
);

export default BannerLoader;
